import React from "react"
import propTypes from "prop-types"
import ReactSelect from "react-select"

import Label from "../Label"
import ErrorMessage from "../ErrorMessage"

const Select = ({ field, onChange, isSubmitted, className }) => {
  const handleChange = value => {
    onChange(field.name, "value", value.value)
  }

  return (
    <div
      className={`form_select ${className} ${
        isSubmitted && !!field.message && field.required ? " is-invalid" : ""
      }`}
    >
      {field.label && <Label label={field.label} htmlFor={field.name} />}

      <ReactSelect
        name={field.name}
        inputId={field.name}
        classNamePrefix="form_select_item"
        options={field.options}
        isOptionDisabled={option => option.disabled}
        onChange={handleChange}
        value={field.options.filter(option => option.value === field.value)}
        placeholder={field.placeholder}
        menuPlacement="auto"
      />

      <ErrorMessage message={field.message} />
    </div>
  )
}

Select.propTypes = {
  field: propTypes.shape({
    label: propTypes.string,
    placeholder: propTypes.string,
    name: propTypes.string.isRequired,
    value: propTypes.oneOfType([propTypes.string, propTypes.number]).isRequired,
    options: propTypes.array,
    message: propTypes.string,
    required: propTypes.bool.isRequired
  }).isRequired,
  className: propTypes.string,
  onChange: propTypes.func.isRequired,
  isSubmitted: propTypes.bool.isRequired
}

Select.defaultProps = {
  className: ""
}

export default Select
